<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/acDKen/tc-custom/9780813177151.jpg?1728851662347" alt="This image is the cover for the book Lincoln, Seward, and U.S. Foreign Relations in the Civil War Era, Studies in Conflict, Diplomacy, and Peace"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lincoln, Seward, and U.S. Foreign Relations in the Civil War Era, Studies in Conflict, Diplomacy, and Peace
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A heartening reminder that politicians, at their best, can rise above petty rivalries and jealousies to serve a larger cause.” —Don H. Doyle, author of <i>The Cause of All Nations: An International History of the American Civil War</i></b><br/>  <br/> The Civil War marked a significant turning point in American history—not only for the United States itself but for its relations with foreign powers both during and after the conflict. The friendship and foreign policy partnership between President Abraham Lincoln and Secretary of State William Henry Seward shaped those US foreign policies. These unlikely allies, who began as rivals during the 1860 presidential nomination, helped ensure that America remained united and prospered in the aftermath of the nation’s consuming war.<br/>  <br/> In <i>Lincoln, Seward, and US Foreign Relations in the Civil War Era</i>, Joseph A. Fry examines the foreign policy decisions that resulted from this partnership and the legacy of those decisions. Lincoln and Seward, despite differences in upbringing, personality, and social status, both adamantly believed in the preservation of the union and the need to stymie slavery. They made that conviction the cornerstone of their policies abroad, and through those policies, such as Seward threatening war with any nation that intervened in the Civil War, they prevented European intervention that could have led to Northern defeat. The Union victory allowed America to resume imperial expansion, a dynamic that Seward sustained beyond Lincoln’s death during his tenure as President Andrew Johnson’s Secretary of State.<br/> Fry’s analysis of the Civil War from an international perspective and the legacy of US policy decisions provides a more complete view of the war and a deeper understanding of this crucial juncture in American history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph A. Fry
      </h2>
      
      <p class="authorDescription body article">Joseph A. Fry is Distinguished Professor of History Emeritus at the University of Nevada, Las Vegas. His books include Dixie Looks Abroad: The South and U.S. Foreign Relations, 1789–1973, Debating Vietnam: Fulbright, Stennis, and Their Senate Hearings,and The American South and the Vietnam War: Belligerence, Protest, and Agony in Dixie.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f80b8c00